import React, { Component } from "react";
import detectBrowser from "detect-browser";
import _ from "underscore";
import { useAuth0 } from "@auth0/auth0-react";

import BaseModal from "../Modals/BaseModal";

require("./UserUnavailable.scss");

export default function UserUnavailable() {
    const auth0 = useAuth0();

    const email = auth0 && auth0.user ? auth0.user.email : null;

    return (
        <BaseModal
            isOpen
            hasCloseButton={false}
            renderWithHeader={true}
            title="Could Not Find Matching User Record"
            shouldCloseOnOverlayClick={false}
        >
            <div className="errorModal container">
                <p>
                    While you entered your credentials correctly, Time Tracker is not able to find a matching record for your email address ({email}).
                </p>
                <p>
                  Please <a href="mailto:EDASales_Support.disw@siemens.com" target="_blank" rel="nofollow noopener">contact EDA Sales Support</a> for assistance.
                </p>
            </div>
        </BaseModal>
    );
}



// WEBPACK FOOTER //
// ./app/components/UserUnavailable/UserUnavailable.jsx